// extracted by mini-css-extract-plugin
module.exports = {"productBrand":"ProductBrand_productBrand__1oz_m","seeStoreWrapper":"ProductBrand_seeStoreWrapper__1D1R_","brandLink":"ProductBrand_brandLink__3uWjP"};